/**
 * @generated SignedSource<<10cd59b189eda295b6d357e0cc430237>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BaseProjectVersionApprovalButtonFragment$data = {
  readonly approval: {
    readonly __typename: "ProjectVersionApproval";
    readonly accept: boolean;
    readonly id: string;
    readonly notes: string | null | undefined;
    readonly scores: ReadonlyArray<{
      readonly competitionScoringCriterion: {
        readonly id: string;
      };
      readonly id: string;
      readonly value: number | null | undefined;
    }>;
  } | null | undefined;
  readonly entity: {
    readonly displayName: string;
    readonly username: string;
  };
  readonly id: string;
  readonly project: {
    readonly competition: {
      readonly id: string;
      readonly scoringCriteria: ReadonlyArray<{
        readonly description: string | null | undefined;
        readonly id: string;
        readonly title: string;
      }>;
    };
    readonly id: string;
  };
  readonly version: string;
  readonly viewerCanApprove: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"SubmissionStatusBadgeFragment">;
  readonly " $fragmentType": "BaseProjectVersionApprovalButtonFragment";
};
export type BaseProjectVersionApprovalButtonFragment$key = {
  readonly " $data"?: BaseProjectVersionApprovalButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BaseProjectVersionApprovalButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BaseProjectVersionApprovalButtonFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectVersionApproval",
      "kind": "LinkedField",
      "name": "approval",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accept",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectVersionApprovalScore",
          "kind": "LinkedField",
          "name": "scores",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompetitionScoringCriterion",
              "kind": "LinkedField",
              "name": "competitionScoringCriterion",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Competition",
          "kind": "LinkedField",
          "name": "competition",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "CompetitionScoringCriterion",
              "kind": "LinkedField",
              "name": "scoringCriteria",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "viewerCanApprove",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_PROJECT_VERSION_APPROVAL"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubmissionStatusBadgeFragment"
    }
  ],
  "type": "ProjectVersion",
  "abstractKey": null
};
})();

(node as any).hash = "00b92d1e183cdec576c6d57379108599";

export default node;
